/**
 * GenderIcon — маленький значок пола (Mars ♂ / Venus ♀) для списка голосов TTS.
 * Пол не указан (null) — значка нет: угадывать по имени не будем.
 */
interface Props {
	gender: 'm' | 'f' | null
	size?: number
}

export default function GenderIcon({ gender, size = 13 }: Props) {
	if (!gender) return null
	if (gender === 'm') {
		return (
			<svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
				<circle cx="6.5" cy="9.5" r="3.8" />
				<path d="M9.4 6.6 L13.5 2.5" />
				<path d="M10 2.5 H13.5 V6" />
			</svg>
		)
	}
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<circle cx="8" cy="6" r="3.8" />
			<path d="M8 9.8 V14.5" />
			<path d="M5.7 12.2 H10.3" />
		</svg>
	)
}
